import React from 'react'
import { DiscordIcon, InstagramIcon } from '../assets/icons'
import { IMAGINE_DISCORD_CHANNEL, IMAGINE_INSTAGRAM_CHANNEL } from '../Helpers/constants'

function JoinCommunity() {
    return (
        <div className='community align-center gap-2'>
            Join our community
            <div className='cursor position-relative discord-icon' onClick={() => window.open( IMAGINE_DISCORD_CHANNEL, "_blank")}>
                <DiscordIcon />
                <div className='tooltip community-tooltip discord-tooltip '>Discord</div>
            </div>
            <div className='cursor position-relative instagram-icon' onClick={() => window.open( IMAGINE_INSTAGRAM_CHANNEL, "_blank")}>
                <InstagramIcon />
                <div className='tooltip community-tooltip instagram-tooltip '>Instagram</div>
                </div>
        </div>
    )
}

export default JoinCommunity